import Forbidden from '../views/Errors/Forbidden.vue';
import NotFound from "@/views/Errors/NotFound.vue"; 

const errorsRoutes = [

    {
        path: "/forbidden",
        name: "Forbidden",
        component: Forbidden, // Página de error 403
    },

    { 
        path: "/:catchAll(.*)", 
        name: "NotFound", 
        component: NotFound 
    }
];

export default errorsRoutes;
